/**
 * @description A handy helper function for refining an optional type. Try it with Array.filter!
 */
function isPresent<T>(value?: T): value is T {
  return value !== undefined;
}

export default isPresent;
